'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resource = function () {
    function Resource(client) {
        (0, _classCallCheck3.default)(this, Resource);

        this.client = client;
    }

    (0, _createClass3.default)(Resource, [{
        key: 'stringForQueryObject',
        value: function stringForQueryObject(queryObject) {
            if (!queryObject) {
                return '';
            }

            return (0, _entries2.default)(queryObject).reduce(function (str, _ref, i) {
                var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                    key = _ref2[0],
                    value = _ref2[1];

                if (typeof value === 'number' || typeof value === 'string') {
                    return '' + str + (i === 0 ? '?' : '&') + key + '=' + value;
                }
                return str;
            }, '');
        }
    }]);
    return Resource;
}();

exports.default = Resource;
//# sourceMappingURL=resource.js.map